/**
 * If the password is not at least 10 characters long, does not contain at least one lowercase
 * letter, one uppercase letter, one number, and one special character, is not a common password,
 * and does not contain three or more repeated characters, then it is a valid password.
 * @returns A boolean value.
 */
export const constraseñaErronea = (password) => {
    // if (password !== null) {
    //     if (password !== undefined) {
    //         /* Checking the password for the following:
    //         1. At least one digit
    //         2. At least one lower case
    //         3. At least one upper case
    //         4. At least one special character
    //         5. At least 10 characters */
    //         var pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{10,}$/;
    //         if (!pattern.test(password)) {
    //             return false;
    //         }
    //         /* Checking if the password is in the commonPasswords array. */
    //         var commonPasswords = ['password', '123456', 'qwerty', 'admin', 'letmein', 'monkey', 'dragon', '111111', 'baseball', 'trustno1'];
    //         if (commonPasswords.includes(password.toLowerCase())) {
    //             return false;
    //         }
    //         /* Checking for repeated characters in a password. */
    //         var repeatedChars = /(.)\1{2,}/;
    //         if (repeatedChars.test(password)) {
    //             return false;
    //         }
    //         return true;
    //     }
    //     return false;
    // }
    // return false;

    // Check if the password is at least 6 characters long
    if (!password || password.length < 6) return false;

    // Check if the password contains at least one uppercase letter
    const hasUppercase = /[A-Z]/.test(password);
    if(!hasUppercase) return false;
    // Check if the password contains at least one number
    const hasNumber = /\d/.test(password);
    if(!hasNumber) return false;

    return true;

}

/**
 * If the email address is not in the form of a string, return false. If the email address is in
 * the form of a string, return true.
 * @returns A boolean value.
 */
export const emailErroneo = (email) => {
    if (email !== null) {
        if (email !== undefined) {
            var validator = require("email-validator");
            return validator.validate(email);

        }
        return false;
    }
    return false;
}

/**
 * If the postal code is not 5 digits, then return false.
 * @returns The function codigoPostalErroneo is being returned.
 */
export const codigoPostalErroneo = (postalCode) => {
    if (postalCode !== null) {
        if (postalCode !== undefined) {
            /* The above code is a regular expression that checks if a string is 5 digits long. */
            var pattern = /^\d{5}$/;
            /* The above code is checking if the postal code is in the correct format. */
            return pattern.test(postalCode);
        }
        return false;
    }
    return false;
}

/**
 * It returns true if the string is a valid Spanish phone number, and false otherwise.
 * @returns A boolean value.
 */
export const telefonoErroneo = (telefono) => {
    if (telefono !== null) {
        if (telefono !== undefined) {
            /* A regular expression that checks if a phone number is valid. */
            var pattern = /^(\+34|0034|34)?[6789]\d{8}$/;
            /* Checking if the phone number is valid. */
            return pattern.test(telefono);
        }
        return false;
    }
    return false;
}

/**
 * If the length of the string is greater than 4, return true, otherwise return false.
 * @returns const datosVacio = (dato) => {
 *         return dato.length > 4
 *     }
 */
export const datosVacio = (dato) => {
    if (dato !== null) {
        if (dato !== undefined) {
            return dato.length > 1
        }
        return false
    }
    return false;
}

export const validarDNI = (dni) => {
    if (dni !== null) {
        if (dni !== undefined) {
            const letras = "TRWAGMYFPDXBNJZSQVHLCKE"; // Letras para calcular el dígito de control
            const dniRegex = /^(\d{8})([A-Z])$/; // Expresión regular para validar el formato

            // Comprobar el formato del DNI
            const match = dni.match(dniRegex);
            if (!match) {
                return false;
            }

            // Calcular el dígito de control y comprobar que es correcto
            const [, numeros, letra] = match;
            const dniNumero = parseInt(numeros, 10);
            const resto = dniNumero % 23;
            const letraCorrecta = letras.charAt(resto);
            return letra === letraCorrecta;
        }
        return false;
    }
    return false;
}

export const validarNISS = (numeroSS) => {
    const regex = /^\d{12}$/;
    return !regex.test(numeroSS);
}
